"use strict";

exports.__esModule = true;
exports.Unwrapped = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _fuzzysearch = _interopRequireDefault(require("fuzzysearch"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _Input = _interopRequireDefault(require("../Input"));

var _Badge = _interopRequireDefault(require("../Badge"));

var _Search = _interopRequireDefault(require("../Icons/Search"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _zIndex = _interopRequireDefault(require("../../constants/z-index"));

var _Options = _interopRequireDefault(require("./Options"));

var _Option = _interopRequireDefault(require("./Option"));

var _MobileHeader = _interopRequireDefault(require("./MobileHeader"));

var _getSelected = _interopRequireDefault(require("./utils/getSelected"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tposition: relative;\n\t", ";\n\t", ";\n\n\t", " {\n\t\tpadding-right: ", " !important;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t", " {\n\t\tflex: 1;\n\n\t\t@media screen and (min-width: ", ") {\n\t\t\tposition: absolute;\n\t\t\ttop: 3.25rem;\n\t\t\tz-index: ", ";\n\t\t}\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tdisplay: inline-block;\n\t", ";\n\n\t", ",\n\t", " {\n\t\tposition: absolute;\n\t\ttop: 18px;\n\t\tright: 10px;\n\t}\n\n\tsvg {\n\t\tposition: absolute;\n\t\ttop: 21px;\n\t\tright: 12px;\n\t}\n\n\t", " {\n\t\tpointer-events: none;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t@media screen and (max-width: ", ") {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground: #fff;\n\t\tz-index: ", ";\n\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t\twidth: 100% !important;\n\t\t\tborder-left: 0 !important;\n\t\t\tborder-right: 0 !important;\n\t\t\tborder-top: 0 !important;\n\t\t\tborder-radius: 0 !important;\n\t\t\tbox-shadow: none !important;\n\t\t\tmargin: 0 !important;\n\t\t}\n\n\t\t", ",\n\t\t.typeahead-add {\n\t\t\ttop: 8px;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Button = _Badge.default.withComponent('button');

Button.displayName = 'Add';
var openCss = (0, _styledComponents.css)(_templateObject(), _breakpoints.default.mobileMax, _zIndex.default.MODAL, _Input.default, _Badge.default);

var InputWrapper = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.fullWidth && 'width: 100%';
}, _Badge.default, Button, _Badge.default);

InputWrapper.displayName = 'InputWrapper';

var Container = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.fullWidth && 'width: 100%';
}, function (props) {
  return props.open && openCss;
}, _Input.default, _spacing.default.s7, _Options.default, _breakpoints.default.tablet, _zIndex.default.MODAL);

Container.displayName = 'Container';

var Typeahead =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Typeahead, _React$Component);

  function Typeahead(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      text: '',
      open: false,
      highlightIndex: 0
    };
    _this.input = _react.default.createRef();
    _this.itemRefs = {};
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Typeahead.prototype;

  _proto.onChange = function onChange(_ref) {
    var value = _ref.target.value;
    this.setState({
      text: value,
      highlightIndex: 0
    });

    if (this.itemRefs['item-0'].current) {
      (0, _scrollIntoViewIfNeeded.default)(this.itemRefs['item-0'].current, {
        behavior: 'smooth',
        scrollMode: 'if-needed'
      });
    }
  };

  _proto.onKeyPress = function onKeyPress(e) {
    var _this2 = this;

    var highlightIndex = this.state.highlightIndex;
    var nextIndex = highlightIndex;
    var isActionKey = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape', 'Tab'].includes(e.key);

    if (!isActionKey) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    if (e.key === 'Enter' && !this.options[highlightIndex].disabled) {
      return this.select(this.options[highlightIndex].id);
    }

    if (e.key === 'Escape' || e.key === 'Tab') {
      return this.setVisible(false);
    }

    if (e.key === 'ArrowDown' && highlightIndex < this.options.length - 1) {
      nextIndex = highlightIndex + 1;
    }

    if (e.key === 'ArrowUp' && highlightIndex > 0) {
      nextIndex = highlightIndex - 1;
    }

    if (nextIndex !== highlightIndex) {
      this.setState({
        highlightIndex: nextIndex
      }, function () {
        (0, _scrollIntoViewIfNeeded.default)(_this2.itemRefs["item-" + nextIndex].current, {
          behavior: 'smooth',
          scrollMode: 'if-needed'
        });
      });
    }
  };

  _proto.setVisible = function setVisible(visible) {
    if (visible === false) {
      this.input.current.blur();
    }

    this.setState({
      open: visible,
      text: ''
    });
  };

  _proto.addItem = function addItem() {
    var onAdd = this.props.onAdd;
    var text = this.state.text;
    this.setState({
      text: ''
    }, function () {
      return onAdd(text);
    });
    this.closeIfNotMultiSelect();
  };

  _proto.closeIfNotMultiSelect = function closeIfNotMultiSelect() {
    var isMultiSelect = this.props.isMultiSelect;

    if (!isMultiSelect) {
      this.setVisible(false);
    }
  };

  _proto.select = function select(id) {
    var _this$props = this.props,
        setSelected = _this$props.setSelected,
        isMultiSelect = _this$props.isMultiSelect,
        selectedItems = _this$props.selectedItems;
    setSelected((0, _getSelected.default)(selectedItems, isMultiSelect, id));
    this.closeIfNotMultiSelect();

    if (!isMultiSelect) {
      this.setVisible(false);
    }
  };

  _proto.handleClickOutside = function handleClickOutside() {
    var open = this.state.open;
    if (!open) return;
    this.setVisible(false);
  };

  _proto.highlight = function highlight(index) {
    this.setState({
      highlightIndex: index
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        selectedItems = _this$props2.selectedItems,
        isMultiSelect = _this$props2.isMultiSelect,
        label = _this$props2.label,
        inputProps = _this$props2.inputProps,
        onAdd = _this$props2.onAdd,
        fullWidth = _this$props2.fullWidth,
        hasError = _this$props2.hasError,
        maxLength = _this$props2.maxLength,
        onMouseDown = _this$props2.onMouseDown,
        x = _this$props2.options,
        y = _this$props2.setSelected,
        disabled = _this$props2.disabled,
        density = _this$props2.density,
        placeholder = _this$props2.placeholder,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["selectedItems", "isMultiSelect", "label", "inputProps", "onAdd", "fullWidth", "hasError", "maxLength", "onMouseDown", "options", "setSelected", "disabled", "density", "placeholder"]);

    var _this$state = this.state,
        open = _this$state.open,
        highlightIndex = _this$state.highlightIndex,
        text = _this$state.text;
    var options = this.options;
    var isButtonDisabled = maxLength !== null && text.length > maxLength;
    return _react.default.createElement(Container, _extends({
      open: open,
      onKeyDown: this.onKeyPress,
      fullWidth: fullWidth
    }, rest), _react.default.createElement(_MobileHeader.default, {
      setVisible: this.setVisible,
      open: open,
      label: label
    }), _react.default.createElement(InputWrapper, {
      fullWidth: fullWidth
    }, _react.default.createElement(_Input.default, _extends({
      placeholder: placeholder,
      hasError: hasError,
      fullWidth: fullWidth
    }, inputProps, {
      onChange: this.onChange,
      value: this.value,
      onFocus: function onFocus() {
        return _this3.setVisible(true);
      },
      ref: this.input,
      disabled: disabled
    })), isMultiSelect && selectedItems.length > 0 ? _react.default.createElement(_Badge.default, {
      color: "primary"
    }, selectedItems.length) : _react.default.createElement(_Search.default, {
      size: 18,
      color: _colors.default.grey
    }), onAdd && text && _react.default.createElement(Button, {
      onClick: this.addItem,
      disabled: isButtonDisabled,
      color: isButtonDisabled ? 'grey' : 'secondary',
      className: "typeahead-add"
    }, "Add")), _react.default.createElement(_Options.default, {
      open: open,
      role: "list",
      density: density
    }, options.map(function (o, i) {
      _this3.itemRefs["item-" + i] = _react.default.createRef();
      return _react.default.createElement(_Option.default, _extends({}, o, {
        key: o.id,
        isMultiSelect: isMultiSelect,
        onClick: function onClick() {
          return o.disabled ? null : _this3.select(o.id);
        },
        selectedItems: selectedItems,
        highlight: highlightIndex === i,
        ref: _this3.itemRefs["item-" + i],
        onMouseEnter: function onMouseEnter() {
          return _this3.highlight(i);
        },
        onMouseDown: onMouseDown,
        role: "listitem",
        density: density
      }));
    }), options.length === 0 && _react.default.createElement(_Option.default, {
      label: "No results",
      isMultiSelect: false,
      selectedItems: [],
      role: "listitem"
    })));
  };

  _createClass(Typeahead, [{
    key: "options",
    get: function get() {
      var _this4 = this;

      return this.props.options.filter(function (o) {
        return (0, _fuzzysearch.default)(_this4.state.text.toLowerCase(), o.label.toLowerCase());
      });
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props3 = this.props,
          selectedItems = _this$props3.selectedItems,
          options = _this$props3.options;
      var _this$state2 = this.state,
          open = _this$state2.open,
          text = _this$state2.text;

      if (open) {
        return text;
      }

      return selectedItems.filter(function (v) {
        return !!v;
      }).map(function (s) {
        return (0, _lodash.default)(options.find(function (o) {
          return o.id === s;
        }), 'label', null);
      }).filter(function (v) {
        return !!v;
      }).join(', ');
    }
  }]);

  return Typeahead;
}(_react.default.Component);

exports.Unwrapped = Typeahead;
Typeahead.propTypes = {
  label: _propTypes.default.string,
  inputProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  selectedItems: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  setSelected: _propTypes.default.func.isRequired,
  isMultiSelect: _propTypes.default.bool,
  onAdd: _propTypes.default.func,
  fullWidth: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string,
    secondaryLabel: _propTypes.default.string,
    disabled: _propTypes.default.bool
  })).isRequired,
  maxLength: _propTypes.default.number,
  onMouseDown: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  density: _propTypes.default.oneOf(['default', 'expanded']),
  placeholder: _propTypes.default.string
};
Typeahead.defaultProps = {
  isMultiSelect: false,
  label: '',
  onAdd: null,
  fullWidth: false,
  hasError: false,
  inputProps: {},
  maxLength: null,
  onMouseDown: undefined,
  disabled: false,
  density: 'default',
  placeholder: 'Search or select'
};

var _default = (0, _reactOnclickoutside.default)(Typeahead);

exports.default = _default;